import { render, staticRenderFns } from "./BoxAssignModal.vue?vue&type=template&id=cc64f528"
import script from "./BoxAssignModal.vue?vue&type=script&lang=js"
export * from "./BoxAssignModal.vue?vue&type=script&lang=js"
import style0 from "./BoxAssignModal.vue?vue&type=style&index=0&id=cc64f528&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports